/* "Try it once" link under Add to Cart, for the subscription-only link
   (?ssavings, layout/theme.liquid; markup in snippets/sub-only-otp-link.liquid).

   A click adds `sub-only-otp` to <html>, which brings One Time Purchase back in
   both pickers (base-custom.css, section-main-product-variant-picker-v2.css),
   selects it, and swaps the link's label to "Back to Subscribe & Save". A second
   click undoes all three. The choice is kept for the visit (the head script in
   theme.liquid restores the class), like the picker's own remembered mode.

   Delegated from document, because product-family swaps, the homepage switcher
   and variant refetches replace the buy box. */
(function () {
  if (window.JiYuSubOtpLink) return;

  var OTP_KEY = 'jiyu:sub-only-otp';
  var MODE_KEY = 'jiyu-sub-mode';
  var root = document.documentElement;

  function store(key, value) {
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function isRendered(el) {
    return !!el && (el.offsetParent !== null || el.getClientRects().length > 0);
  }

  // Select a mode in every visible picker the way a click would: `change` runs
  // each picker's own handlers, so prices, panel styling and the add-to-cart
  // selling plan follow (global.js, section-main-product-variant-picker-v2.js).
  function selectMode(mode) {
    var wantSub = mode === 'subscription';
    document
      .querySelectorAll('input[name^="vp-v2-mode-"][value="' + mode + '"]')
      .forEach(function (radio) {
        if (radio.disabled || radio.checked || !isRendered(radio.closest('.vp-v2__mode'))) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    document.querySelectorAll('.nx-sub-toggle__checkbox[data-nx-sub-toggle]').forEach(function (box) {
      if (box.disabled || box.checked === wantSub || !isRendered(box.closest('.nx-sub-toggle'))) return;
      box.checked = wantSub;
      box.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function setOneTime(on) {
    root.classList.toggle('sub-only-otp', on);
    store(OTP_KEY, on ? '1' : null);
    store(MODE_KEY, on ? 'onetime' : 'subscription');
    selectMode(on ? 'onetime' : 'subscription');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-sub-otp-toggle]');
    if (!btn) return;
    event.preventDefault();
    setOneTime(!root.classList.contains('sub-only-otp'));
  });

  // The per-jar price follows the selected variant. The element is replaced, not
  // edited, so Intelligems re-applies a test group's price to it (it does that
  // for inserted price elements, as the V2 picker relies on).
  function updatePrice(link, variantId) {
    var data;
    try {
      data = JSON.parse(link.querySelector('[data-sub-otp-variants]').textContent);
    } catch (e) {
      return;
    }
    var v = data.variants && data.variants[String(variantId)];
    var old = link.querySelector('[data-sub-otp-price]');
    if (!v || !old) return;
    var span = document.createElement('span');
    span.className = 'sub-otp-link__price igPrice';
    span.setAttribute('data-sub-otp-price', '');
    span.setAttribute('data-product-id', data.productId);
    span.setAttribute('data-variant-id', variantId);
    if (v.mult && Math.abs(v.mult - 1) > 1e-9) span.setAttribute('data-price-multiplier', v.mult);
    span.textContent = v.money;
    old.replaceWith(span);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      var sectionId = event.data.sectionId;
      var scope = (sectionId && document.getElementById('MainProduct-' + sectionId)) || document;
      scope.querySelectorAll('[data-sub-otp-link]').forEach(function (link) {
        updatePrice(link, variant.id);
      });
    });
  }

  window.JiYuSubOtpLink = { setOneTime: setOneTime };
})();
